import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div>
      <h2>Page not found</h2>
      <p>The page you are looking for does not exist.</p>
      <Link className="primary-link" to="/dashboard">
        Back to Dashboard
      </Link>
    </div>
  );
}

export default NotFoundPage;
